import { Component, Input, AfterViewInit, ViewChild, ElementRef, Output, EventEmitter, OnInit, SkipSelf, Host, Optional, TemplateRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormControl, ControlContainer, AbstractControl } from '@angular/forms';

@Component({
  selector: 'wn-input',
  templateUrl: './wn-input.component.html',
  styleUrls: ['./wn-input.component.css'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: WnInputComponent,
    multi: true
  }]
})
export class WnInputComponent implements OnInit, AfterViewInit, ControlValueAccessor {

  constructor( @Optional() @Host() @SkipSelf() private controlContainer: ControlContainer ) { }

  @ViewChild('InputField', {static: false}) inputField: ElementRef;

  @Input() optionsTemplate: TemplateRef<any>;
  @Input() formControlName: string;
  public control: AbstractControl;
  
  @Input('class')  class: string = '';
  @Input('id')  id: string = '';

  @Input('placeholder')  placeholder: string = '';
  @Input('type')  type: string = 'text';
  @Input('disabled')  disabled: boolean = false;
  @Input('readonly')  readonly: boolean = false;
  @Input('autocomplete')  autocomplete: string = 'on';


  @Input('number') number: boolean = false;
  @Input('pattern') pattern: string = '';

  @Input('max') max: string = '';
  @Input('min') min: string = '';

  @Input('rows') rows: string = '';
  @Input('cols') cols: string = '';

  @Input('errors') errors: any = undefined;
  @Input('errorClass') errorClass: string = 'wn-error';

  @Output('keypress') keypress: EventEmitter<any> = new EventEmitter();
  @Output('keyup') keyup: EventEmitter<any> = new EventEmitter();
  @Output('keydown') keydown: EventEmitter<any> = new EventEmitter();

  @Output('focusout') focusout: EventEmitter<any> = new EventEmitter();
  @Output('focusin') focusin: EventEmitter<any> = new EventEmitter();
  @Output('blur') blur: EventEmitter<any> = new EventEmitter();

  // @Output('change') change: EventEmitter<any> = new EventEmitter();

  // @Input('inputModel') inputModel set();
  // @Output() inputModelChange = new EventEmitter<string>();

  //The internal data model for form control value access
  public value: any = '';
  public errorMessage: string = undefined;
  public inputFocus: boolean = false;
  private allowKeys: string[] = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 
  'Control', 'Shift', 'Alt', 'CapsLock', 'Tab', 'PageUp', 'PageDown'];
  
  // Tell FormControl about value changed
  onChange: ( value: any ) => void;
  onTouched: ( ) => void;

  ngOnInit(): void {
    this.getFormControl();
  }

  ngAfterViewInit(): void {

    // this.inputField.nativeElement.value = this.value;
    // // Setting FormControl Initial Value
    // this.value = this.control.value;
    
    // // Setting the value if updated in FormControl 
    // this.control.valueChanges.subscribe(
    //   () => {

    //       this.value = this.control.value;
    //       // check condition if the form control is RESET
    //       // if (this.control.value == "" || this.control.value == null || this.control.value == undefined) {
    //       //     this.innerValue = "";      
    //       //     this.inputField.nativeElement.value = "";                 
    //       // }
    //       // else {
    //       //   this.innerValue = this.control.value;      
    //       //   this.inputField.nativeElement.value = this.control.value;
    //       // }
    //   }
    // );

  }

  writeValue(obj: any): void {
    this.value = obj;
    this.updateErrors();
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    
  }
  
  


  /*
  **
  **  Data Handler Functions
  **
  */

  onChangeModel( event ){

    // console.log('Update:', this.value);
    if( this.control ){
      this.onChange(this.value);
      this.updateErrors();
    }
    
  }

  validateRegex( value ){

    if(this.value == undefined || this.value == '' || this.value == null ) this.value = '';

    // value means event value 
    let fieldValue = this.value + '' + value;
    if(this.pattern){

      let regExp = RegExp(this.pattern);
      // console.log('reg:', regExp);
      return regExp.test( fieldValue );
      
    }
    else {
      return true;
    }

  }

  updateErrors( ){

    // reset error message
    this.errorMessage = undefined;

    if(this.control && this.control.errors ){
      for( let [key, value] of Object.entries(this.control.errors) ){

        if( this.errors && this.errors.hasOwnProperty(key)) this.errorMessage = this.errors[key];
        else{
          
          if(key == 'required') this.errorMessage = 'This field is required'; 
          else if (key == 'required')   this.errorMessage = 'This field is required';
          else if (key == 'pattern')    this.errorMessage = `Invalid value`;
          else if (key == 'minlength')  this.errorMessage = `Minimum length should be ${value.requiredLength}`;
          else if (key == 'min')  this.errorMessage = `Minimum value should be ${value.min}`;
          else if (key == 'maxlength')  this.errorMessage = `Maximum length should be ${value.requiredLength}`;
          else if (key == 'max')  this.errorMessage = `Maximum value should be ${value.max}`;
          // else if (key == 'pattern') this.errorMessage = ` ${value.reqiredLength}`;
          else this.errorMessage = 'Invalid value';
        }
  
        // After 1 iteration it should be break to only show first error
        break;
  
      }
    }

  }

  getFormControl(){

    if( !this.controlContainer ){
      console.log('Parent Form Group not found');
      return;
    }

    if( !this.formControlName ){
      console.log('Missing FormControlName directive from host element of the component');
      return;
    }

    this.control = this.controlContainer.control.get(this.formControlName);

    try{
      this.control.valueChanges.subscribe(() => {
        this.updateErrors();
      });
    }
    catch(Excp){
      console.log('Error on Form Control Name:', this.formControlName);
      console.log(Excp);
    }
    

  }





  /*
  **
  **  EVENTS
  **
  */

  onKeyPress(event){
    this.keypress.emit(event);
  }

  onKeyUp(event){ 
    this.keyup.emit(event);
  }

  onKeyDown(event){

    this.keydown.emit(event);
    let key = event.key;

    if( this.allowKeys.includes(key) ){
      return;
    }

    if(this.pattern){
      if(!this.validateRegex(key)){
        return event.preventDefault();
      }
    }

    if(this.number){
      if(key == ' ' || isNaN(key)){
        event.preventDefault();
      }
    }

  }

  onPaste(event){

    let eventText = event.clipboardData.getData('text');
    
    if(this.pattern){
      if(!this.validateRegex(eventText)){
        return event.preventDefault();
      }
    }

    if(this.number){
      if(eventText == ' ' || isNaN(eventText)){
        event.preventDefault();
      }
    }

  }

  onFocusOut(event){
    this.focusout.emit(event);
    this.inputFocus = false;

    if( this.control ){
      this.onTouched();
      this.updateErrors();
    }
    
  }
  onFocusIn(event){
    this.focusin.emit(event);
    this.inputFocus = true;

    if( this.control ){
      this.onTouched();
      this.updateErrors();
    }

  }
  onBlur(event){
    this.blur.emit(event);
  }

  // onChangeEvent( event ){

  //   this.change.emit(event);
  //   this.updateErrors();

  // }
  


}
